import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link as ScrollLink } from 'react-scroll'
import {
  LinkIcon
} from '../'
import Styles from './ScrollToTop.css'

@CSSModules(Styles, {allowMultiple: true})
export default class ScrollToTop extends Component {
  static propTypes = {
    color: PropTypes.string,
  }
  constructor(props){
    super(props)
    this.state = {
      color: props.color || ''
    }
  }

  render() {
    return (
      <button styleName={'scroll-to-top ' + this.state.color}>
        <ScrollLink to='top' spy smooth offset={-50} duration={500}>
          <p><LinkIcon nospace faclass='fa-arrow-circle-o-up'/> Scroll to top</p>
        </ScrollLink>
      </button>
    )
  }
}